import { Box, SxProps } from '@mui/material';
import { FunctionComponent } from 'react';
import { useRerenderInterval } from '../../../core/hooks';
import { L3ServiceViewModel } from '../../model';
import {
  getIconComponent,
  getStatusIcon,
  getStatusIconBackgroundColor,
  getStatusIconMaintenanceProgressBorderLineStyle,
  getStatusIconColor,
  getStatusIconMaintenanceProgressBorderColor,
  L3ServiceStatusIconModel,
  calculateMaintenanceWorkPercentageProgress,
} from './L3ServiceSatusIcon.model';

interface Props {
  l3Service: L3ServiceViewModel;
}

const getStatusIconConfiguration = (l3Service: L3ServiceViewModel): L3ServiceStatusIconModel => ({
  icon: getStatusIcon(l3Service),
  iconColor: getStatusIconColor(l3Service),
  backgroundColor: getStatusIconBackgroundColor(l3Service),
  maintenanceProgressBorderLineStyle: getStatusIconMaintenanceProgressBorderLineStyle(l3Service),
  maintenanceProgressBorderColor: getStatusIconMaintenanceProgressBorderColor(l3Service),
  workProgress: calculateMaintenanceWorkPercentageProgress(l3Service.maintenanceWorks),
});

export const L3ServiceStatusIcon: FunctionComponent<Props> = ({ l3Service }) => {
  useRerenderInterval(5000);

  const iconConfig = getStatusIconConfiguration(l3Service);
  const icon = getIconComponent(iconConfig);

  const styles: SxProps = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 50,
    height: 50,
    borderRadius: '50%',
    background: `
      radial-gradient(closest-side, transparent 80% 100%),
      conic-gradient(${iconConfig.maintenanceProgressBorderColor} ${iconConfig.workProgress}%, ${iconConfig.backgroundColor} 0)`,
  };

  return <Box sx={{
    position: 'relative',
    border: `2px ${iconConfig.maintenanceProgressBorderLineStyle} ${iconConfig.maintenanceProgressBorderColor}`,
    p: '2px',
    width: 'min-content',
    borderRadius: '50%',
  }}
  >
    <Box sx={styles}
         aria-valuemin={0}
         aria-valuemax={100}
         aria-valuenow={iconConfig.workProgress}></Box>
    {icon}
  </Box>;
};
